import { signOut } from "next-auth/react";
import baseUrl from "@/utils/baseUrl";
import { openConfirmModal } from "@mantine/modals";

const getErrorMessage = (error) => {
  if (error.response) {
    const contentType = error.response.headers["content-type"];

    if (contentType && !contentType.includes("application/json")) {
      return "The server returned an unexpected response. Please try again later.";
    }

    return (
      error.response.data?.error?.message ||
      error.response.data?.message ||
      error.response.data ||
      "An unexpected error occurred, please try again later."
    );
  }

  if (error.message) {
    return error.message;
  }

  return "Network error. Please check your connection or try again later.";
};

const showSessionExpiredModal = () => {
  openConfirmModal({
    title: "Your session has expired",
    children: <p>Please log in to continue.</p>,
    labels: { confirm: "Log in" },
    withCloseButton: false,
    closeOnEscape: false,
    closeOnClickOutside: false,
    classNames: { title: "confirm-modal-title" },
    confirmProps: {
      classNames: { root: "default-btn" },
    },
    cancelProps: {
      styles: { root: { display: "none" } },
    },
    onConfirm: () => {
      signOut({ callbackUrl: `${baseUrl}/authentication` });
    },
  });
};

const catchErrors = (error, toastError) => {
  const errorMsg = getErrorMessage(error);

  if ([401, 403].includes(error.response?.status)) {
    showSessionExpiredModal();
    return;
  }

  toastError(errorMsg?.slice(0, 250));
};

export default catchErrors;
